import { Box, Typography, Stack, useTheme, Grid } from "@mui/material";

import { imageSource, Strings } from "@app/constants";

interface PremiumServicesSectionProps {}

const PremiumServicesSection: React.FC<PremiumServicesSectionProps> = () => {
  const theme = useTheme();

  const services = [
    {
      img: imageSource.refreshRightSquare,
      title: Strings.home.hoursSupport,
      desc: Strings.home.reliableAssistance,
    },
    {
      img: imageSource.medalStar,
      title: Strings.home.qualifiedAssurance,
      desc: Strings.home.everyVehicleIs,
    },
    {
      img: imageSource.gps,
      title: Strings.home.gpsOnCars,
      desc: Strings.home.driverSmarter,
    },
    {
      img: imageSource.crown,
      title: Strings.home.whyKaizen,
      desc: Strings.home.continuousImprovement,
    },
  ];

  return (
    <Stack
      sx={{
        position: "relative",
        height: "auto",
      }}
    >
      <Box
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: "white",
          py: 8,
          px: 4,
          mt: 8,
          textAlign: "center",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: { xs: 0, md: 320 },
          height: { xs: 200, md: "auto" },
          mb: { xs: 0, md: 20 },
          pb: { xs: 0, md: 20 },
        }}
      >
        <Stack sx={{ marginBottom: 13 }}>
          <Typography
            variant="h1"
            fontWeight="bold"
            gutterBottom
            sx={{
              fontSize: { xs: 32, sm: 44 },
              fontFamily: "Work Sans",
              fontWeight: "700",
            }}
          >
            {Strings.heading.aboutUs}
          </Typography>
          <Typography
            variant="body1"
            sx={{
              maxWidth: 640,
              mx: "auto",
              fontSize: { xs: 14, sm: 16 },
              color: theme.palette.common.white,
              fontFamily: "Work Sans",
              fontWeight: "400",
            }}
          >
            {Strings.home.handpickedTopCondition}
          </Typography>
        </Stack>
      </Box>
      <Stack
        sx={{
          position: { xs: "relative", md: "absolute" },
          bottom: 0,
          width: "100%",
          backgroundColor: {
            xs: theme.palette.primary.main,
            md: "transparent",
          },
          pb: { xs: 10, md: 0 },
        }}
      >
        <Grid
          container
          spacing={3}
          justifyContent="center"
          sx={{
            maxWidth: 1200,
            mx: "auto",
            px: { xs: 2, md: 4 },
          }}
        >
          {services.map((item, index) => (
            <Grid
              key={index}
              size={{ xs: 12, sm: 6, md: 3 }}
              sx={{
                display: "flex",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  backgroundColor: "white",
                  p: 4,
                  borderRadius: 2,
                  boxShadow: "0 8px 24px rgba(0,0,0,0.1)",
                  textAlign: "center",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "100%",
                  maxWidth: 280,
                  minHeight: 300,
                }}
              >
                <img
                  src={item.img}
                  alt={item.title}
                  style={{ width: 60, marginBottom: 12 }}
                />

                <Typography
                  sx={{
                    fontWeight: 500,
                    color: theme.palette.primary.main,
                    mb: 1,
                  }}
                  variant="h6"
                >
                  {item.title}
                </Typography>

                <Typography variant="body2">{item.desc}</Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
};

export { PremiumServicesSection };
